import {
  Box,
  Typography,
  createTheme,
  ThemeProvider,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import Stack from "@mui/material/Stack";
import HelpIcon from "@mui/icons-material/Help";
import GroupIcon from "@mui/icons-material/Group";
import MUIDataTable from "mui-datatables";
import { makeStyles } from "@mui/styles";
import { Placeholder } from "react-bootstrap";
import Divider from "@mui/material/Divider";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import HouseIcon from "@mui/icons-material/House";
import CampaignIcon from "@mui/icons-material/Campaign";
import ViewListIcon from "@mui/icons-material/ViewList";
import Events from "../Events/events";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CakeIcon from "@mui/icons-material/Cake";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { liveTrackingApi } from "../../Data/axios";
import { useSelector } from "react-redux";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function PrivateDash() {
  const userValue = useSelector((state) => state.user);
  const user = JSON.parse(localStorage.getItem("user-info"));
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  //*********************** */ My tasks**********************************

  const Taskcolumns = [
    {
      name: "",
      label: "Task#", // to rename column
    },
    {
      name: "",
      label: "Task",
    },
    {
      name: "",
      label: "Status",
    },
    {
      name: "",
      label: "Due Date",
    },
  ];

  // ******************Tickets *************************************

  const Ticketcolumns = [
    {
      name: "",
      label: "Tickets#", // to rename column
    },
    {
      name: "",
      label: "Ticket Subject ",
    },
    {
      name: "",
      label: "Status",
    },
    {
      name: "",
      label: "Requested On",
    },
  ];
  const columnsEmployee = [
    {
      name: "",
      label: "Name", // to rename column
    },
    {
      name: "",
      label: "Time ",
    },
    {
      name: "",
      label: "Others",
    },
    {
      name: "",
      label: "Action",
    },
  ];
  const options = {
    selectableRows: "none",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 100],
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
        marginLeft: "5PX",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  //const classes = useStyles();

  // ********************My calender**********************************8
  const theme = useTheme();
  //const colors = tokens(theme.palette.mode);

  // const handleDateClick = (selected) => {
  //   const title = prompt('Please enter a new title for your event');
  //   const calendarApi = selected.view.calendar;
  //   calendarApi.unselect();

  //   if (title) {
  //     calendarApi.addEvent({
  //       id: `${selected.dateStr}-${title}`,
  //       title,
  //       start: selected.startStr,
  //       end: selected.endStr,
  //       allDay: selected.allDay,
  //     });
  //   }
  // };

  // const handleEventClick = (selected) => {
  //   if (
  //     window.confirm(
  //       `Are you sure you want to delete the event '${selected.event.title}'`
  //     )
  //   ) {
  //     selected.event.remove();
  //   }
  // };

  const getEmpIdFromLocalStorage = () => {
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    return userInfo?.value?.empid || "";
  };
  const DataWithoutHeadingTable = ({ data }) => {
    return (
      <table>
        <tbody style={{ height: "250px", overflow: "hidden" }}>
          {data.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <tr>
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    style={{
                      backgroundColor:
                        cellIndex === 2 ? "#16FF00" : "transparent",
                      borderRadius:
                        cellIndex === 2 && rowIndex > -1 ? "50px" : "25px",
                      width: "300px",
                      overflow: "hidden",
                      fontSize:
                        cellIndex === 2 && rowIndex > -1 ? "10px" : "15px",
                    }}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
              {rowIndex < data.length - 1 && (
                <tr>
                  <td colSpan={row.length}>
                    <hr />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    );
  };

  const dataTable = [
    createData(
      "09-04-2024",
      "Tuesday",
      "General Shift",
      "This is default shift"
    ),
    createData(
      "10-04-2024",
      "Wednesday",
      "General Shift",
      "This is default shift"
    ),
    createData(
      "11-04-2024",
      "Thursday",
      "General Shift",
      "This is default shift"
    ),
    createData(
      "12-04-2024",
      "Friday",
      "General Shift",
      "This is default shift"
    ),
    createData(
      "13-04-2024",
      "Saturday",
      "General Shift",
      "This is default shift"
    ),
  ];

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 300 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
    },
  }));
  const [timelogs, setTimelogs] = useState({ weeklyTime: 50, breaks: 0 });

  useEffect(() => {
    // Simulating real-time data fetching
    const interval = setInterval(() => {
      // Fetch your real-time data here and update state
      setTimelogs({ weeklyTime: 50, breaks: 0 }); // Replace with actual data fetching
    }, 500000); // Update every 5 seconds

    return () => clearInterval(interval);
  }, []);
  const [dateTime, setDateTime] = useState(new Date());
  const [nowDay, setNowDay] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDateTime(new Date());
    }, 500000); // Update every second

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setNowDay(new Date());
    }, 500000); // Update every second

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);
  const getDatesOfWeek = (date) => {
    const dayOfWeek = date.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diff = date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Start date of the week (Saturday)
    const startDate = new Date(date.setDate(diff));
    const dates = [];

    for (let i = 0; i < 7; i++) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);
      dates.push(currentDate);
    }

    return dates;
  };

  // Format date in dd-MM-yyyy format
  const formattedDates = getDatesOfWeek(dateTime).map((date) =>
    new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date)
  );
  // Get day of the week
  const dayOfWeekToday = nowDay.toLocaleString("en-IN", { weekday: "short" });

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  // Testing Live Tracking //

  const [liveLocationData, setLiveLocationData] = useState(null);
  const userId = "RPTPLDRV1726551820";

  // useEffect(() => {
  //   // Start tracking when the component mounts
  //   const stopTracking = liveTrackingApi.startTracking(userId, (data) => {
  //     setLiveLocationData(data); // Update state with new location data
  //   });

  //   // Stop tracking when the component unmounts
  //   return () => stopTracking();
  // }, [userId]);

  // Testing Ends //
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleShift = () => {};
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const columnsShift = [
    { id: "date", label: "", minWidth: 170 },
    { id: "week", label: "", minWidth: 100 },
    {
      id: "shift",
      label: "",
      minWidth: 170,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "statement",
      label: "",
      minWidth: 170,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
  ];
  function createData(date, week, shift, statement) {
    return { date, week, shift, statement };
  }

  return (
    <Grid container spacing={1}>
      {/* first column */}
      <Grid item xs={12} md={6}>
        {/* first row */}
        <Grid
          container
          spacing={1}
          direction="row"
          style={{ marginBottom: "14px" }}
        >
          <Grid item xs={12}>
            <Item style={{ backgroundColor: "#fff", color: "black" }}>
              <Stack direction="row">
                {userValue.image !== null ? (
                  <div>
                    <img
                      src={userValue.image}
                      alt=""
                      sx={{
                        color: "grey",
                        fontSize: "120px",
                        justifyContent: "left",
                      }}
                    />
                  </div>
                ) : (
                  <AccountBoxIcon
                    sx={{
                      color: "grey",
                      fontSize: "120px",
                      justifyContent: "left",
                    }}
                  />
                )}
                <Typography
                  component="div"
                  sx={{
                    marginTop: "20px",
                    textAlign: "left",
                    paddingLeft: "20px",
                  }}
                >
                  <div>
                    <h1 style={{ color: "black", fontSize: "20px" }}>
                      {userValue.name}
                    </h1>
                    <p style={{ color: "grey" }}>{userValue.role}</p>
                    <p style={{ color: "grey" }}>{userValue.empid}</p>

                    {/* Testing starts */}

                    {/* <p style={{ color: "grey" }}>
                      {liveLocationData
                        ? `Latitude: ${liveLocationData.latitude}, Longitude: ${liveLocationData.longitude}`
                        : "---"}
                    </p> */}
                    {/* Testing ends */}
                  </div>
                </Typography>
              </Stack>
            </Item>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={1}
          direction="row"
          style={{ marginBottom: "10px" }}
        >
          <Grid item xs={6}>
            <Item
              style={{
                height: "80px",
                backgroundColor: "#fff",
                marginTop: "-5px",
              }}
            >
              <Stack
                direction="row"
                width="100%"
                textAlign="center"
                spacing={2}
              >
                <Typography
                  component="div"
                  variant="body2"
                  style={{ fontSize: "15px" }}
                  color="black"
                >
                  <p style={{ color: "grey" }}>In Progress</p>
                  <br></br>25
                </Typography>
              </Stack>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item
              style={{
                height: "80px",
                backgroundColor: "#fff",
                marginTop: "-5px",
              }}
            >
              <Stack
                direction="row"
                width="100%"
                textAlign="center"
                spacing={2}
              >
                <Typography
                  component="div"
                  variant="body2"
                  style={{ fontSize: "15px" }}
                  color="black"
                >
                  <p style={{ color: "grey" }}>Overdue</p>
                  <br></br>0
                </Typography>
              </Stack>
            </Item>
          </Grid>
        </Grid>

        {/* second row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  alignItems: "center",

                  position: "sticky",
                  bgcolor: "#fff",
                }}
              >
                <Typography
                  gutterBottom
                  variant="subtitle1"
                  style={{
                    textAlign: "left",
                    fontSize: "20px",
                    color: "#161e29",
                    fontWeight: 600,
                  }}
                >
                  Shift Schedule
                </Typography>
                <Box
                  sx={{
                    bgcolor: "#1d82f5",
                    color: "#fff",
                    padding: "2px 8px",
                    fontSize: "20px",
                    fontWeight: 500,
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={handleClickOpen}
                >
                  Employee Shift
                </Box>

                <BootstrapDialog
                  onClose={handleClose}
                  aria-labelledby="customized-dialog-title"
                  open={open}
                >
                  <DialogTitle
                    sx={{ m: 0, p: 2, bgcolor: "#fff", color: "#000" }}
                    id="customized-dialog-title"
                  >
                    Employee Shift
                  </DialogTitle>
                  <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: theme.palette.grey[900],
                    })}
                  >
                    <CloseIcon />
                  </IconButton>
                  <DialogContent
                    dividers
                    sx={{
                      bgcolor: "#fff",
                      color: "#000",
                      borderTop: "1px solid grey ",
                    }}
                  >
                    <ThemeProvider theme={getTheme()}>
                      <MUIDataTable
                        fullScreen={true}
                        columns={columnsEmployee}
                        options={options}
                      />
                    </ThemeProvider>
                  </DialogContent>
                  <DialogActions sx={{ bgcolor: "#fff", color: "#000" }}>
                    <Button autoFocus onClick={handleClose}>
                      Cancel
                    </Button>
                  </DialogActions>
                </BootstrapDialog>
              </Box>
              <TableContainer
                sx={{ maxHeight: 440, bgcolor: "#fff", color: "#000" }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead></TableHead>
                  <TableBody>
                    {dataTable
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id || `${row.code}-${index}`} // Ensure uniqueness
                          >
                            {columnsShift.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={`${column.id}-${row.id || index}`} // Unique key for each cell
                                  align={column.align}
                                  sx={{ color: "#000" }}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                sx={{ bgcolor: "#fff", color: "#000" }}
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={dataTable.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Grid>
        </Grid>

        {/* third row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
                height: "auto",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                Birthdays
              </Typography>
              {/* <Typography variant="body2" gutterBottom style={{ textAlign:w "center", color: "#4d4f5c" }}>
                      <MilitaryTechIcon />
                    </Typography>
                    <Typography variant="body2" style={{ textAlign: "center", fontSize: "16px", color: "#4d4f5c" }}>
                      <Placeholder>-Not Enough Data-</Placeholder>
                    </Typography>
                    <div style={{ marginBottom: "200px" }}></div> */}
              <List sx={{ maxwidth: "600px", bgcolor: "#fff" }}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AccountCircleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText>Andrew</ListItemText>
                  <ListItemText>
                    <CakeIcon />
                    17 Apr
                  </ListItemText>
                  <ListItemText>11 months after</ListItemText>
                </ListItem>
                <Divider component="li" style={{ backgroundColor: "grey" }} />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AccountCircleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText>Albert</ListItemText>
                  <ListItemText>
                    <CakeIcon />1 may
                  </ListItemText>
                  <ListItemText>11 months after</ListItemText>
                </ListItem>
                <Divider component="li" style={{ backgroundColor: "grey" }} />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AccountCircleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText>Bohr</ListItemText>
                  <ListItemText>
                    <CakeIcon />
                    24 Aug
                  </ListItemText>
                  <ListItemText>3 months after</ListItemText>
                </ListItem>
                <Divider component="li" style={{ backgroundColor: "grey" }} />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AccountCircleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText>David</ListItemText>
                  <ListItemText>
                    <CakeIcon />8 Jan
                  </ListItemText>
                  <ListItemText>10 months after</ListItemText>
                </ListItem>
                <Divider component="li" style={{ backgroundColor: "grey" }} />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AccountCircleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText>John</ListItemText>
                  <ListItemText>
                    <CakeIcon />
                    21 Feb
                  </ListItemText>
                  <ListItemText>9 months after</ListItemText>
                </ListItem>
              </List>
            </Item>
          </Grid>
        </Grid>

        {/* fourth row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
                height: "auto",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                Employee Appreciation
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{
                  textAlign: "center",
                  color: "#4d4f5c",
                  paddingTop: "20px",
                }}
              >
                <Person2OutlinedIcon />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#4d4f5c",
                  marginBottom: "50px",
                }}
              >
                <Placeholder>-Not Enough Data-</Placeholder>
              </Typography>
            </Item>
          </Grid>
        </Grid>
        {/* fifth row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                On Leave Today
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "center", color: "#4d4f5c" }}
              >
                <FlightTakeoffIcon />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#4d4f5c",
                  marginBottom: "50px",
                }}
              >
                <Placeholder>-Not Enough Data-</Placeholder>
              </Typography>
            </Item>
          </Grid>
        </Grid>

        {/* sixth row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                On Work From Home Today
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "center", color: "#4d4f5c" }}
              >
                <HouseIcon />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#4d4f5c",
                  marginBottom: "50px",
                }}
              >
                <Placeholder>-Not Enough Data-</Placeholder>
              </Typography>
            </Item>
          </Grid>
        </Grid>

        {/* seventh row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                Today's Joinings & Work Anniversary
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "center", color: "#4d4f5c" }}
              >
                <CampaignIcon />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#4d4f5c",
                  marginBottom: "50px",
                }}
              >
                <Placeholder>-Not Enough Data-</Placeholder>
              </Typography>
            </Item>
          </Grid>
        </Grid>

        {/* eighth row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                Notice Period Duration
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "center", color: "#4d4f5c" }}
              >
                <ViewListIcon />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#4d4f5c",
                  marginBottom: "50px",
                }}
              >
                <Placeholder>-Not Enough Data-</Placeholder>
              </Typography>
            </Item>
          </Grid>
        </Grid>

        {/* nine row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                Probation Date
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "center", color: "#4d4f5c" }}
              >
                <ViewListIcon />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#4d4f5c",
                  marginBottom: "50px",
                }}
              >
                <Placeholder>-Not Enough Data-</Placeholder>
              </Typography>
            </Item>
          </Grid>
        </Grid>

        {/* ten row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                Internship Date
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "center", color: "#4d4f5c" }}
              >
                <ViewListIcon />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#4d4f5c",
                  marginBottom: "50px",
                }}
              >
                <Placeholder>-Not Enough Data-</Placeholder>
              </Typography>
            </Item>
          </Grid>
        </Grid>

        {/* eleven row */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                Contract Date
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "center", color: "#4d4f5c" }}
              >
                <ViewListIcon />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#4d4f5c",
                  marginBottom: "50px",
                }}
              >
                <Placeholder>-Not Enough Data-</Placeholder>
              </Typography>
            </Item>
          </Grid>
        </Grid>
      </Grid>

      {/* second column  */}
      <Grid item xs={12} md={6}>
        {/* first row  */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={6}>
            <Item
              elevation={2}
              style={{ backgroundColor: "#fff", height: "150px" }}
            >
              <Stack
                direction="row"
                width="100%"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "15px",
                }}
              >
                <Typography
                  gutterBottom
                  variant="subtitle1"
                  style={{
                    textAlign: "left",
                    fontSize: "20px",
                    color: "#161e29",
                    fontWeight: 600,
                  }}
                >
                  Tasks
                </Typography>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ textAlign: "right", color: "#4d4f5c" }}
                >
                  <GroupIcon></GroupIcon>
                </Typography>
              </Stack>
              <Stack
                direction="row"
                width="100%"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "15px",
                }}
                spacing={2}
              >
                <Typography
                  component="div"
                  variant="body2"
                  style={{ textAlign: "left", fontSize: "15px" }}
                  color="red"
                >
                  25<br></br>
                  <p style={{ color: "#4d4f5c" }}>Pending</p>
                </Typography>
                <Typography
                  component="div"
                  variant="body2"
                  style={{ textAlign: "left", fontSize: "15px" }}
                  color="blue"
                >
                  5<br></br>
                  <p style={{ color: "#4d4f5c" }}>Overdue</p>
                </Typography>
              </Stack>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item
              elevation={2}
              style={{ backgroundColor: "#fff", height: "150px" }}
            >
              <Stack
                direction="row"
                width="100%"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "15px",
                }}
              >
                <Typography
                  gutterBottom
                  variant="subtitle1"
                  style={{
                    textAlign: "left",
                    fontSize: "20px",
                    color: "#161e29",
                    fontWeight: 600,
                  }}
                >
                  Projects
                </Typography>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ textAlign: "right", color: "#4d4f5c" }}
                >
                  <GroupIcon></GroupIcon>
                </Typography>
              </Stack>
              <Stack
                direction="row"
                width="100%"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "15px",
                }}
                spacing={2}
              >
                <Typography
                  component="div"
                  variant="body2"
                  style={{ textAlign: "left", fontSize: "15px" }}
                  color="red"
                >
                  25<br></br>
                  <p style={{ color: "#4d4f5c" }}>In Progress</p>
                </Typography>
                <Typography
                  component="div"
                  variant="body2"
                  style={{ textAlign: "left", fontSize: "15px" }}
                  color="blue"
                >
                  5<br></br>
                  <p style={{ color: "#4d4f5c" }}>Overdue</p>
                </Typography>
              </Stack>
            </Item>
          </Grid>
        </Grid>

        {/* second row  */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                height: "130px",
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Stack direction="row" spacing={2}>
                <Typography
                  sx={{ fontSize: "20px", color: "#161e29", fontWeight: 600 }}
                >
                  Weekly Timelogs
                </Typography>
                {/* <Typography
                  component="div"
                  sx={{ fontSize: "11px", marginLeft: "8px" }}
                >
                  <p style={{ backgroundColor: "grey" }}>
                    {timelogs.weeklyTime}s this week
                  </p>
                </Typography> */}
              </Stack>
              <br />

              <Stack direction="row" spacing={1}>
                {days.map((day, index) => (
                  <Tooltip
                    title={formattedDates[index]}
                    arrow
                    key={index}
                    PopperProps={{
                      sx: {
                        "& .MuiTooltip-tooltip": {
                          backgroundColor: "#ffffff", // Brighter background color
                          color: "#000000", // Text color (brighter contrast)
                          fontWeight: "bold", // Optional for better visibility
                        },
                        "& .MuiTooltip-arrow": {
                          color: "#ffffff", // Match arrow color with background
                        },
                      },
                    }}
                  >
                    <Button
                      sx={{
                        borderRadius: "100%",
                        backgroundColor:
                          dayOfWeekToday === day ? "#6420AA" : "inherit",
                      }}
                    >
                      {day}
                    </Button>
                  </Tooltip>
                ))}
              </Stack>
              <br />
              {/* <Tooltip title={`${timelogs.weeklyTime}s`} arrow>
                <BorderLinearProgress
                  variant="determinate"
                  value={timelogs.weeklyTime}
                  style={{ color: "grey" }}
                />
              </Tooltip> */}
              <Tooltip title={`${timelogs.weeklyTime || 0}s`} arrow>
                <BorderLinearProgress
                  variant="determinate"
                  value={Number(timelogs.weeklyTime) || 0}
                />
              </Tooltip>

              <Stack direction="row" component="div">
                <div>
                  {/* <p>Duration: {timelogs.weeklyTime}s</p> */}
                  {/* <p style={{ marginLeft: "460px" }}>
                    Breaks: {timelogs.breaks}s
                  </p> */}
                </div>
              </Stack>
            </Item>
          </Grid>
        </Grid>

        {/* third row  */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <ThemeProvider theme={getTheme()}>
                <MUIDataTable
                  title={
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: "20px",
                        color: "#161e29",
                        textAlign: "left",
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      My Tasks
                    </div>
                  }
                  columns={Taskcolumns}
                  options={{
                    ...options,
                    setTableProps: () => ({
                      style: {
                        textAlign: "left", // Ensures alignment remains consistent
                      },
                    }),
                  }}
                />
              </ThemeProvider>
            </Item>
          </Grid>
        </Grid>

        {/* fourth row  */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <ThemeProvider theme={getTheme()}>
                <MUIDataTable
                  title={
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: "20px",
                        color: "#161e29",
                        textAlign: "left",
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      Tickets
                    </div>
                  }
                  columns={Ticketcolumns}
                  options={{
                    ...options,
                    setTableProps: () => ({
                      style: {
                        textAlign: "left", // Ensures alignment remains consistent
                      },
                    }),
                  }}
                />
              </ThemeProvider>
            </Item>
          </Grid>
        </Grid>

        {/* fifth row  */}
        <Grid
          container
          spacing={1}
          direction="row"
          style={{ marginBottom: "10px" }}
        >
          <Grid item xs={12}>
            <Item
              style={{
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                My Calender
              </Typography>
              <Events></Events>
            </Item>
          </Grid>
        </Grid>

        {/* sixth row  */}
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Item
              style={{
                height: "120px",
                backgroundColor: "#fff",
                color: "black",
                marginTop: "10px",
              }}
            >
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  fontSize: "20px",
                  color: "#161e29",
                  fontWeight: 600,
                }}
              >
                Notices
              </Typography>
            </Item>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PrivateDash;
